import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { getConfig } from 'src/app/core/services/functions.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  public DATE: Date = new Date();
  public APP_NAME: string;
  public DEVELOPER: string;
  public DEVELOPER_LINK: string;
  public VERSION: string;

  @ViewChild('footerElement', { static: true }) footerElement!: ElementRef;
  private resizeObserver!: ResizeObserver;

  constructor() {
    this.APP_NAME = getConfig("app_title");
    this.DEVELOPER = getConfig("app_developer");
    this.DEVELOPER_LINK = getConfig("app_developer_link");
    this.VERSION = getConfig("app_version");
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    this.setFooterHeight();
    this.resizeObserver = new ResizeObserver(() => {
      this.setFooterHeight();
    });
    if (this.footerElement?.nativeElement) {
      this.resizeObserver.observe(this.footerElement.nativeElement);
    }
  }

  setFooterHeight() {
    if (this.footerElement?.nativeElement) {
      const footerHeight = this.footerElement.nativeElement.offsetHeight;
      document.documentElement.style.setProperty('--footer-height', `${footerHeight}px`);
    }
  }

  ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }
}
